var React = require('react');

function QuestionCircleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"question-circle","d":"M18.7 5c-.9-1.5-2.1-2.7-3.6-3.6C13.5.4 11.8 0 10 0S6.5.4 5 1.3C3.4 2.2 2.2 3.4 1.3 5 .4 6.5 0 8.2 0 10s.4 3.5 1.3 5 2.1 2.7 3.6 3.6S8.2 20 10 20s3.5-.4 5-1.3 2.7-2.1 3.6-3.6c.9-1.5 1.3-3.2 1.3-5s-.4-3.6-1.2-5.1zM9.9 16.1c-.9 0-1.5-.7-1.5-1.5s.6-1.4 1.5-1.4 1.5.6 1.4 1.5c0 .8-.6 1.4-1.4 1.4zm3.6-7.2c-.2.3-.6.6-1.2 1.1l-.6.4c-.3.3-.5.5-.6.7-.1.2-.1.2-.1.6v.1H8.6v-.2c0-.8 0-1.3.4-1.7.5-.6 1.7-1.4 1.7-1.4.2-.1.3-.3.4-.4.2-.3.4-.6.4-.9 0-.4-.1-.7-.3-1-.2-.2-.6-.3-1.2-.3s-.9.2-1.2.5c-.2.4-.3.8-.3 1.2v.1H6.1v-.1c.1-1.5.6-2.5 1.6-3.2.6-.4 1.3-.6 2.2-.6 1.2 0 2.2.3 2.9.8.8.7 1.2 1.5 1.2 2.6 0 .6-.1 1.2-.5 1.7z"}));
}

QuestionCircleIcon.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = QuestionCircleIcon;

QuestionCircleIcon.default = QuestionCircleIcon;
